<div class="dialog-header">
  <h2>Request Service</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <button
    *ngFor="let service of services"
    class="service-btn"
    [class.disabled]="service.used >= service.total"
    (click)="selectService(service)"
  >
    {{ service.name }} {{ service.used }}/{{ service.total }}
  </button>
</div>
